import axios from '../../app/api/axios_agep';
import {
    SCHOOLS_LOADING,
    GET_SCHOOLS_DROPDOWN,
} from "./types"

export const getSchoolsDropdown = () => dispatch => {
    dispatch(setSchoolsLoading());

    axios
        .get('agep/v1/schools_dropdown')
        .then(res =>
            dispatch({
                type: GET_SCHOOLS_DROPDOWN,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_SCHOOLS_DROPDOWN,
                payload: null
            })
        );
};

export const setSchoolsLoading = () => {
    return {
        type: SCHOOLS_LOADING
    };
};



// WEBPACK FOOTER //
// ./src/features/Schools/actions.js